module.exports = __webpack_public_path__ + "assets/img/jiantou.af9d96ce.svg";